<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <div class="search-summary__block">
            <div
                v-for="t in SEQUENCE_TYPES"
                :key="t"
                class="search-summary__option"
            >
                <label>
                    <input
                        v-model="fieldValue"
                        :value="t"
                        type="radio"
                        @change="syncChange"
                    >
                    <span>
                        {{ $t(`Search.btns.${t.toLowerCase()}`) }}
                    </span>
                </label>
            </div>
        </div>
    </FieldItem>
</template>

<script>
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { SEQUENCE_TYPES } from '../constants/index';

export default {
    components: {
        FieldItem,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'sequenceType',
        },
    },
    data() {
        return {
            SEQUENCE_TYPES,
        };
    },
};
</script>
